<template>
    <div class="fixedUiElements">
        <div class="audioFiles">
            <audio ref="strikeAudio" :src="strikeAudio" preload="auto"></audio>
            <audio ref="strikeAudio2" :src="strikeAudio2" preload="auto"></audio>
            <audio ref="longStrike" :src="longStrike" preload="auto"></audio>
            <audio ref="winner" :src="winner" preload="auto"></audio>
            <audio ref="losser" :src="losser" preload="auto"></audio>
            <audio ref="soundOn" :src="soundOn" preload="auto"></audio>
        </div>
        <div class="developerName">
            By 
            <a href="#" @click.prevent="openBaji()" >Baji</a> 
            with
            <unicon name="heart" />
        </div>
        <unicon class="helpIcon" @click="toggleHowToPlayModal()" name="question-circle" />
        <unicon class="soundSwitchIcon" @click="switchSound()" :name="isSoundOn?'volume':'volume-mute'" />
        <b-modal size="lg" v-model="howToPlayModal" title="How To Play" ok-only >
            <ul class="howToPlayUl">
                <li>Create a room and invite friends to your room using room link/id</li>
                <li>The rules of this game are quite simple.</li>
                <li>Each player will be having a board of 25 squares having numbers 1 to 25.</li>
                <li>The tricky part is that each player's numbers are randomly ordered.</li>
                <li>When the turn comes player should strike off any non striked number, this will be striked in all the other player's board.</li>
                <li>Players objective is to make 5 consecutive squares striked (vertically, horizontally and diagonally) making a long strike</li>
                <li>The first player to get 5 long strikes wins the game.</li>
            </ul>
            <div class="howToImage">
                <img src="../assets/images/HowToPlay.jpg">
            </div>
        </b-modal>
        <b-modal centered size="lg" v-model="invalidLink" title="Invalid Room Link" ok-only hide-header button-size="sm">
            <h6>Not a valid room link open this link in a browser</h6><br>
            <a href="#" @click.prevent="openInvalidLink()">{{invalidLinkUrl}}</a>
        </b-modal>
        <b-modal 
        centered 
        button-size="sm"
        :visible="showJoinRoomModal"
        :hide-header="true"
        @ok="joinRoomFromLink()"
        @cancel="cancelJoin()"
        >
        {{openRoomFromLink}}
        </b-modal>
    </div>
</template>

<script>
import strikeAudio from '../assets/sounds/penStrike.mp3'
import strikeAudio2 from '../assets/sounds/penStrike2.mp3'
import longStrike from '../assets/sounds/longStrike.mp3'
import winner from '../assets/sounds/winner.mp3'
import losser from '../assets/sounds/losser.mp3'
import soundOn from '../assets/sounds/soundOn.mp3'
import config from '../config'
import store from '@/store'
import Server from "@/server";
import Helpers from "@/helpers";
export default {
    data:function(){
        return{
            strikeAudio,
            strikeAudio2,
            longStrike,
            winner,
            losser,
            soundOn
        }
    },
    computed:{
        isSoundOn:()=>store.state.sound.isSoundOn,
        isMobile:()=>(window.cordova)?true:false,
        developerUrl:()=>config.developerUrl,
        playStoreUrl:()=>config.playStoreUrl,
        invalidLinkUrl:()=>store.state.invalidLink,
        openRoomFromLink:()=>(store.state.room.myRoom)?'Do you want to leave current room and join this room ?':'Do you want to join this room ?',
        howToPlayModal: {
            get() {
                return store.state.howToPlayModal;
            },
            set(value) {
                store.state.howToPlayModal = value;
            },
        },        
        invalidLink: {
            get() {
                return store.state.invalidLink!==false;
            },
            set(value) {
                store.state.invalidLink = value;
            },
        },        
        showJoinRoomModal:()=>store.state.roomIdFromLink!==false
    },
    methods:{
        toggleHowToPlayModal(){
            this.howToPlayModal = !this.howToPlayModal;
        },switchSound(){
            store.dispatch('switchSound',!this.isSoundOn);
        },openBaji(){
            window.openNewWindow(config.developerUrl,'_system');
        },openInvalidLink(){
            window.openNewWindow(this.invalidLinkUrl,'_system');
        },joinRoomFromLink(){
            if(store.state.room.myRoomId == store.state.roomIdFromLink){
                store.state.roomIdFromLink = false;
                return;
            }
            Server.leaveRoom();
            Server.joinBingoRoom(store.state.roomIdFromLink);
            store.state.roomIdFromLink = false;
        },
        cancelJoin(){
            store.state.roomIdFromLink = false;
        }
    },mounted:function() {
        store.state.sounds = this.$refs;
        store.state.sound.soundElements = this.$refs;
    }
}
</script>